export default __webpack_public_path__ + "static/media/8.ecad1ec5.svg";